"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateInFuture = isDateInFuture;
exports.isDateInPast = isDateInPast;
exports.isDateInRange = isDateInRange;
const date_1 = require("./date");
/**
 * @description Compares dt to current time. (current can be debug)
 * @description False if equal or fail.
 */
function isDateInFuture(dt) {
    try {
        if (typeof dt === 'string') {
            if (new date_1.EventrDate(dt).getUnixMs > new date_1.EventrDate().getUnixMs) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return dt.getUnixMs > new date_1.EventrDate().getUnixMs;
        }
    }
    catch {
        /// Error with parsing date
        return false;
    }
}
/**
 * @description Compares dt to current time. (current can be debug)
 * @description False if equal or fail.
 */
function isDateInPast(dt) {
    try {
        const currentDateInMill = new date_1.EventrDate().getUnixMs;
        if (dt === '') {
            return false;
        }
        if (typeof dt === 'string') {
            if (new date_1.EventrDate(dt).getUnixMs < currentDateInMill) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return dt.getUnixMs < currentDateInMill;
        }
    }
    catch {
        /// Error with parsing date
        return false;
    }
}
/**
 * @description Check that the date is in the range if one is given. true for same
 */
function isDateInRange(date, max, min, ignoreTime = false) {
    if (date && ignoreTime === false) {
        if (min) {
            if (date.getUnixMs < min.getUnixMs) {
                return false;
            }
        }
        if (max) {
            if (date.getUnixMs > max.getUnixMs) {
                return false;
            }
        }
        return true;
    }
    else if (date && ignoreTime === true) {
        /// Use datetimes with same time for comparison
        const dateNormalised = date.getCloneEventrDate();
        dateNormalised.setFromObject({
            hour: 12,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        if (min) {
            const minNormalised = min.getCloneEventrDate();
            minNormalised.setFromObject({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });
            if (dateNormalised.getUnixMs < minNormalised.getUnixMs) {
                return false;
            }
        }
        if (max) {
            const maxNormalised = max.getCloneEventrDate();
            maxNormalised.setFromObject({
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 999,
            });
            if (dateNormalised.getUnixMs > maxNormalised.getUnixMs) {
                return false;
            }
        }
        return true;
    }
    else {
        return true;
    }
}
